import { AxiosResponse } from 'axios';
import { PAGE_SIZE } from '../../constants';
import { accessTypes } from '../../utils/AccessTypes';
import { isActive } from '../../utils/isActive';
import api from '../../utils/api';
import {
  ExternalUser,
  ExternalUserResponse,
  GetExternalUsersResponse,
  UserCompanies,
} from './types';
import { Group, Company } from '../../types';

export async function getExternalUsers(
  page?: number,
  pageSize?: number,
  search = '',
): Promise<GetExternalUsersResponse> {
  const { data, headers } = await api.get<ExternalUser[]>('/user_customer', {
    ...(page
      ? {
          params: {
            page,
            size: pageSize || PAGE_SIZE,
            ...(search ? { search } : {}),
          },
        }
      : {}),
  });

  const users: ExternalUserResponse[] = data.map(user => {
    return {
      ...user,
      isActive: isActive(user.status),
      type: 'Cliente',
      formattedAccessType: accessTypes[user.accessType as keyof Object],
    };
  });

  const totalCount = Number(headers['x-total-count']);

  return {
    users,
    totalCount,
  };
}

export async function getExternalUserById(
  id: number,
): Promise<ExternalUserResponse> {
  const { data } = await api.get<ExternalUser>(`/user_customer/${id}`);

  return {
    ...data,
    isActive: isActive(data.status),
    type: 'Cliente',
    formattedAccessType: accessTypes[data.accessType as keyof Object],
  };
}

export async function deleteExternalUserById(
  id: number,
): Promise<AxiosResponse<any>> {
  return api
    .put(`/user_customer/${id}/empresas`, [])
    .then(response => api.delete(`/user_customer/${id}`));
}

export async function updateExternalUserById(
  id: number,
  data: any,
): Promise<AxiosResponse<any>> {
  return api.put(`/user_customer/${id}`, data);
}

export async function getCompaniesByExternalUser(
  id: number,
): Promise<UserCompanies> {
  const response = await api.get<{ id_empresa: Company }[]>(
    `/user_customer/${id}/empresas`,
  );

  const companies = response.data.map(company => company.id_empresa);
  const groups: Group[] = [];

  const groupIds = companies
    .filter(c => !!c.grupoeconomico.id_grupoeconomico)
    .map(company => company.grupoeconomico.id_grupoeconomico)
    .reduce(
      (unique: number[], item: number) =>
        unique.includes(item) ? unique : [...unique, item],
      [],
    );

  // eslint-disable-next-line no-restricted-syntax
  for await (const groupId of groupIds) {
    const { data } = await api.get<Group>(`/grupoeconomico/${groupId}`);
    groups.push(data);
  }

  return {
    companies,
    groups,
  };
}
